module.exports = __webpack_public_path__ + "img/home_advantage.414e8916.png";